import { formatPrice } from '@/shared/utils/priceFormatter';

type AmountSelectorProps = {
  displayAmounts: number[];
  isLoading: boolean;
  onSelectAmount: (val: number) => void;
};

export const AmountSelector = ({
  displayAmounts,
  isLoading,
  onSelectAmount,
}: AmountSelectorProps) => {
  if (isLoading) {
    return (
      <div className="flex gap-2 my-2">
        {[1, 2, 3, 4].map((i) => (
          <div key={i} className="flex-1 h-10 bg-gray-200 animate-pulse rounded" />
        ))}
      </div>
    );
  }

  return (
    <div className="flex gap-2 my-2 overflow-x-auto">
      {displayAmounts.map((amt) => (
        <button
          key={amt}
          type="button"
          onClick={() => onSelectAmount(amt)}
          className="flex-1 px-1 h-10 border border-gray-300 text-xs font-medium text-[#682332] rounded hover:bg-gray-100 transition-colors bg-[#FFF2F5]"
        >
          {formatPrice(amt)}
        </button>
      ))}
    </div>
  );
};